import { render } from "./SubpageNav.vue?vue&type=template&id=15b598b0&scoped=true"
const script = {}

import "./SubpageNav.vue?vue&type=style&index=0&id=15b598b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b598b0"]])

export default __exports__